// extracted by mini-css-extract-plugin
module.exports = {"main":"App_main__2a5c9","control":"App_control__G3x71","button":"App_button__2k4fN"};